export default "__VITE_ASSET__BbAh_vLW__"